module.exports = __webpack_public_path__ + "img/icon-location.d6c398dd.svg";